export const keyword = {
  APPLICATION_ROLE: 'Application Role',
  ORGANIZATION: 'Organization',
  EXTERNAL_STORAGE: 'External Storage',
  LOCAL_STORAGE: 'Local Storage',
  DMCA: 'DMCA',
  INDEXES: 'INDEXES',
  REVIEW: 'REVIEW',
  KEYWORD: 'KEYWORDS',
  DETAILS: 'DETAILS',
  BULK_UPLOAD: 'BULK UPLOAD',
  ARCHIVES: 'ARCHIVES',
};

export const columnKeyword = {
  ACTION: 'action',
  NOISE_ACTION: 'noiseAction',
  GENERATED_DMCA: 'isDmcaGenerated',
  REVIEWED: 'isReviewed',
  REVIEW_STATUS: 'reviewPercentage',
  MARK_FOR_ARCHIVE: 'markForArchive',
  MARK_YOUR_PREFERENCE: 'Markyourpreference',
  NUMBER: 'number',
  STATUS: 'status',
  SRC_DOWNLOAD: 'src-download',
  ERR_DOWNLOAD: 'err-download',
  CATEGORY_ACTION: 'categoryAction',
  CATEGORY_NAME: 'categoryName',
  KEYWORD_ACTON: 'keywordAction',
  KEYWORD_TEXT: 'keywordText',
  COPY_OPEN: 'copy/open',
  SITE_STATUS: 'siteStatus',
};

export const successMessage = {
  CATEGORY_ADD: 'Category added successfully',
  CATEGORY_ACTIVATE: 'Category activated successfully',
  CATEGORY_DEACTIVATE: 'Category deactivated successfully',
  CATEGORY_DELETE: 'Category delete successfully',
  CATEGORY_UPDATE: 'Category update successfully',
  CATEGORY_LABEL_ADD: 'Category label added successfully!',
  CATEGORY_LABEL_DELETE: 'Category label deleted successfully!',
  CATEGORY_LABEL_UPDATE: 'Category label updated successfully',
  KEYWORD_ADD: 'Keyword Added successfully',
  KEYWORD_DELETE: 'Keyword deleted successfully!',
  FILE_UPLOAD: 'File uploaded successfully',
  CRAWL_INIT: 'Crawling started!',
  CRAWL_START: 'Indexing started!',
  CRAWL_TERMINATE: 'Terminated successfully!',
  CRAWL_UPDATE: 'Crawl data updated successfully',
  ARCHIVE_SUCCESS: 'Archived successfully',
  RESEND_EMAIL: 'Mail sent successfully!',
  RESET_PASSWORD: 'Password reset successfully',
  HIT_COUNT_RESTARTED: 'Hit count re-started successfully',
  CRAWL_RESTART: 'Crawling re-started successfully!',
  DMCA_GENERATE: 'DMCA generated successfully',
  KEYWORDS_GENERATE_REPORT:'Keywords report generated successfully ',
  SITE_INDEX_DELETE: 'Site index deleted successfully!',
  SITE_INDEX_ACTIVATE: 'Index activated successfully',
  SITE_RECRAWL_REQUEST: 'Recrawl requested successfully',
  SITE_DELETE: 'Site deleted successfully!',
  SITE_UPDATE: 'Site updated successfully',
  SITE_ORGANIZATION_UPDATE:"Site organization updated successfully",
  SITE_ADD: 'Website added successfully',
  MARKED_PREFERENCE: 'Marked preference successfully! ',
  REVIEW_SUCCESS: 'Reviewed successfully!',
  NOISEWORD_ADD: 'Noise word added successfully',
  NOISEWORD_UPDATE: 'Noise word update successfully',
  NOISEWORD_DELETE: 'Noise word delete successfully',
  ORGANIZATION_UPDATE: 'Organization storage updated successfully',
  ORGANIZATIONSETTING_UPDATE: 'Setting updated successfully',
  ORGANIZATION_DELETE: 'Organization was deleted successfully!',
  PASSWORD_UPDATE: 'Password updated.',
  PROFILE_UPDATE: 'Your profile updated successfully',
  ROLE_ADD: 'Role added successfully',
  ROLE_UPDATE: 'Organization role update successfully',
  ROLE_DELETE: 'Role delete successfully',
  STORAGE_UPDATE: 'Storage updated successfully',
  STORAGE_DELETE: 'Server was deleted successfully!',
  RECALCULATE: 'Re-calculating the memory! It may take sometime',
  RESEND_CODE: 'Code sent successfully!',
  USER_ADD: 'User added successfully',
  USER_DELETE: 'User delete successfully',
  USER_UPDATE: 'User update successfully',
  BACKUP_UPDATE: 'Backup settings updated successfully',
  ORGANIZATIONS_UPDATE: 'Organization updated successfully'
  

};
